export default __webpack_public_path__ + "static/media/dnv-left.a285e4d7.png";